import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { UIRouter }                from '@uirouter/core';
import { TranslateService }       from '@ngx-translate/core';

import { ApiService }            from '../api/api.service';
import { CompanyMessagesModel }  from '../companies/models/company.messages';
import { CompanyService }        from '../companies/company.service';
import { ConfirmService }        from '../messages/confirm/confirm.service';
import { MessagesService }       from '../messages/messages.service';
import { MessengerService }      from '../messages/messenger/messenger.service';
import { Table }                 from '../table/types/table';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { TableService }          from '../table/table.service';
import { VendorModel }           from './models/vendor';
import { VendorActionsComponent } from './vendor.actions.component';

@Component({
  selector   : 'wor-vendors-list',
  template: require('./vendors.list.component.html')
})
export class VendorsListComponent implements AfterViewInit, OnInit {
  @Input() vendors: any;
  @Input() companyMessages: CompanyMessagesModel;
  @Input() actionsFactory: any;

  filtering: any;
  tableSettings: Table;

  private tableCacheKey = 'vendors';

  constructor (
    private apiService       : ApiService,
    public  companyService   : CompanyService,
    private confirmService   : ConfirmService,
    private messagesService  : MessagesService,
    private messengerService : MessengerService,
    private router           : UIRouter,
    private tableService     : TableService,
    private translateService : TranslateService
  ) {}

  ngOnInit () {
    const actionsFactory = this.actionsFactory || VendorActionsComponent;

    this.filtering = this.tableService.setFiltersFromCache(this.tableCacheKey, {
      archived_only: false,
      value        : ''
    });

    this.tableSettings = {
      broadcast: 'filterVendors',
      cache    : {
        enabled: true,
        key    : this.tableCacheKey
      },
      columns: [
        {
          field : 'company_name',
          header: { text: this.translateService.instant('VENDOR_SPACE.SUPPLIER') }
        },
        {
          field : 'suburb',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.SUBURB') }
        },
        {
          field : 'phone',
          header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.PHONE_NUMBER') },
          pipe  : 'mobilePhone'
        },
        {
          field : 'web',
          header: { text: this.translateService.instant('JS_SPACE.COLUMNS.WEBSITE') }
        },
        {
          component: {
            bindings: {
              outputs: {
                onEditClick         : event => this.viewVendor(event),
                onInvoiceClick      : event => this.createInvoice(event),
                onPurchaseOrderClick: event => this.createPurchaseOrder(event),
                onPaymentClick      : event => this.createPayment(event),
                onSMSClick          : event => this.sendSMS(event),
                onEmailClick        : event => this.sendEmail(event),
                onActivateClick     : event => this.activate(event)
              }
            },
            enabled: true,
            factory: actionsFactory
          },
          sortable: false
        }
      ],
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_SUPPLIERS_FOUND')
      },
      pagination: {
        enabled   : true,
        pageSize  : this.tableService.getCachedPaging(this.tableCacheKey).pageSize || 10,
        pageSizes : [ 10, 25, 50 ],
        queryCount: () => this.apiService.get('/filters/count', [
          this.filtering.value || '*',
          'vendors',
          this.filtering.archived_only
        ])
      },
      rows: {
        highlight: { enabled: true }
      },
      sorting: this.tableService.setSortingFromCache(this.tableCacheKey, {
        direction: 'asc',
        field    : 'company_name'
      })
    };
  }

  ngAfterViewInit (): void {
    const interval = setInterval(() => {
      if (typeof window['filterVendors'] === 'function') {

        clearInterval(interval);

        this.onFiltersChanged();

      }
    }, 100);
  }

  activate ( event : VendorModel ) : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', { name: event.company_name }))
    .then(() => this.apiService.get('/vendors/reactivate_deleted', event.id))
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SUPPLIER_REACTIVATED'), 'success');
      this.router.stateService.reload();
    })
    .catch(err => this.messagesService.error(err));
  }

  createInvoice ( vendor : VendorModel ) : void {


    this.router.stateService.go('app.vendor-invoice', { vendor_id: vendor.id });


  }

  createPayment ( event : VendorModel ) : void {
    if (event.is_branch_vendor) {
      this.router.stateService.go('app.vendor-branch-payment', { vendor_id: event.id });
    } else {
      this.router.stateService.go('app.vendor-payment', { vendor_id: event.id });
    }
  }

  createPurchaseOrder ( vendor : VendorModel ) : void {


    this.router.stateService.go('app.purchase-order', { vendor_id: vendor.id });


  }

  getVendors ( params : TableQueryParameters ) : Promise<any> {
    return this.apiService.stream('/filters', [
      this.filtering.value || '*',
      'vendors',
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
      this.filtering.archived_only
    ]).then(vendors => {
      this.vendors = vendors;
      return vendors;
    });
  }

  onFiltersChanged () : void {


    window['filterVendors'](this.filtering);


  }

  sendEmail ( row : VendorModel ) : void {
    this.messengerService.email({
      name           : row.company_name,
      email_address  : row.email,
      body           : this.companyMessages?.supplier_email_message,
      attachment_type: 5,
      vendor_id      : row.id
    })
    .then(() => this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success'));
  }

  sendSMS ( row : VendorModel ) : void {
    this.messengerService.sms({
      name   : row.company_name,
      send_to: row.mobile
    })
    .then(() => this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success'));
  }

  viewVendor ( vendor : VendorModel ) : void {


    this.router.stateService.go('app.vendor', { id: vendor.id });


    };


  }
